import {Component, OnInit, Input, ViewChild} from '@angular/core';
import { SafeResourceUrl,ɵe } from '@angular/platform-browser';
import {NgbActiveModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup, FormBuilder, Validators} from '@angular/forms';
import {ConfirmationService, Message } from 'primeng/api';
import {DialogModule} from 'primeng/dialog';
import {LogService} from '../../services/log.service';
import {Log} from '../../model/log';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {MessageService} from 'primeng/components/common/messageservice';
import {BranchesShowComponent} from '../../views/setting/branches/branches-show/branches-show.component';
import {TranslateService} from '@ngx-translate/core';
import {appConfig} from '../../app.config';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import {ActivatedRoute, Router} from '@angular/router';
import { ImageViewerModule } from 'ng2-image-viewer';

declare let scanner;
declare const imagesScanned:any[];
//declare let downfil:any;
//declare let downfils;

 function processOriginal(scannedImage:any) {
        console.log('>>mmohaed');
        console.log(scannedImage);
        if(scannedImage){
            localStorage.setItem('scannedImage', JSON.stringify(scannedImage));
            document.getElementById('filedisu').style.display = 'block';
//            downfil=this.translate.instant('File Downloaded');
//            downfils = true;
        }

    }

@Component({
    selector: 'app-app-arc',
    templateUrl: './app-arc.component.html',
    styleUrls: ['./app-arc.component.scss'],
    providers: [ConfirmationService,DialogModule,MessageService,ɵe,PdfViewerModule,ImageViewerModule]
})

export class AppArcComponent implements OnInit {
  http: any;
  public logs: Log[];
    @Input() rowId;
    @Input() refShow;
  @Input() screenName;
  @Input() allowaction = true;

  modalRef: NgbModalRef;
    allcategory: any[] = [];
    category_data: any;
    filedis: any;
    filedisext: any;
    filedisid: any;
    filedisindex: any;
    fromscanner:any;
    zoom_to=0.5;
    rotate_to=0;
    fittowidth:any = false;
    switch:any = 0;
    file_data: any[] = [];
    allfiles: any[] = [];
    catfilter: any[] = [];
    filedetails: any[] = [];
    checkedall=true;
    form: FormGroup;
    form2: FormGroup;
    is_edit = true;
    display = false;
    form1error = false;
    form2error = false;
    downfil:any;
    downfils = false;
    msgs: Message[] = [];
    scannedImages: any[] =[];
   imagesScanned:any[] = [];
    categ_delete_error:any="";
    categ_delete_error_h:any="";

    switcherd = false;
    public imgUrl = appConfig.apiUrl;


    constructor(public activeModal: NgbActiveModal,
                public logService: LogService,
                public translate: TranslateService,
                private formBuilder: FormBuilder,
                private formBuilder2: FormBuilder,
                private confirmationService: ConfirmationService,
                private dialogModule: DialogModule,
                private messageService: MessageService,
                private sanitizer: ɵe,
                private pdfviewer: PdfViewerModule,
                private router: Router,
                private modalService: NgbModal,) {


    }

    ngOnInit() {
         this.logService.getfilesById(this.rowId).subscribe(
            allfiles => {
                this.allfiles = allfiles;
                console.log(allfiles);
            },
            err => {
                console.log(err);
            }
        );
         this.logService.getallCategory(this.screenName).subscribe(
            categories => {
                this.allcategory = categories;
                for (let bran of  categories) {
                    this.catfilter.push(bran.value);
                }
                console.log(categories);
            },
            err => {
                console.log(err);
            }
        );
         if(this.allowaction){

           this.form = this.formBuilder.group({
             name: new FormControl(''),

           });

           this.form2 = this.formBuilder2.group({
             files_categories_id: new FormControl('', Validators.required),
             document_name: new FormControl('', Validators.required),
             browsefile: new FormControl('', Validators.required),
           });
         } else{
           this.switcherd = true;
           this.form = this.formBuilder.group({
             name: new FormControl({value: '', disabled: true}),

           });

           this.form2 = this.formBuilder2.group({
             files_categories_id: new FormControl({value: '', disabled: true}, Validators.required),
             document_name: new FormControl({value: '', disabled: true}, Validators.required),
             browsefile: new FormControl({value: '', disabled: true}, Validators.required),
           });
         }

      console.log(this.allowaction);
      console.log(this.switcherd);

    }

    onSubmit() {
        this.msgs = [];
        this.form2error=false;
//        document.getElementById('catloader').style.display = 'block';
        document.getElementById('catloader11').style.display = 'block';
        let check=1;
        for (let bran of  this.allcategory) {
                if (bran.label == this.form.controls['name'].value) {
                    check=2;
                }
        }
        if (this.form.controls['name'].value =='') {
            check=0;
        }
        console.log(check);
        if(check==1) {
            this.form1error=false;
            this.category_data = {name: this.form.controls['name'].value, screen: this.screenName};
            console.log(this.category_data);
            let parm = JSON.stringify(this.category_data);
             this.logService.create(parm).subscribe(
                categories => {
                    this.allcategory = categories;
//                    document.getElementById('catloader').style.display = 'none';
                    document.getElementById('catloader11').style.display = 'none';
                    console.log(categories);
                    this.form.reset();
                },
                err => {
                    console.log(err);
                    document.getElementById('catloader').style.display = 'none';
                    document.getElementById('catloader11').style.display = 'none';

                }
            );
        }
        if(check==0){
            this.form1error=true;
            this.msgs = [];
            this.msgs.push({
                severity: 'error',
                summary: '',
                detail: this.translate.instant('Please fill Cat')
            });
//            document.getElementById('catloader').style.display = 'none';
            document.getElementById('catloader11').style.display = 'none';
        }
        if(check==2){
            this.form1error=true;
            this.msgs = [];
            this.msgs.push({
                severity: 'error',
                summary: '',
                detail: this.translate.instant('Please fill Cat2')
            });
//            document.getElementById('catloader').style.display = 'none';
            document.getElementById('catloader11').style.display = 'none';
        }
        document.getElementById('filedisu').style.display = 'none';
    }


    onSubmit2() {
        this.form1error=false;
         if(this.fromscanner == 1){
            const scanfile = JSON.parse(localStorage.getItem('scannedImage'));

            this.form2.get('browsefile').setValue({
                    filename: 'file.pdf',
                    filetype: scanfile.mimeType,
                    value: scanfile.src

                })
        }
        if (this.form2.valid){
            this.msgs = [];
            this.form2error=false;
            this.downfils = false;
//        document.getElementById('catloader2').style.display = 'block';
        document.getElementById('catloader22').style.display = 'block';

        this.file_data = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        let userid:any = 0;
        if (userdata && userdata.id) {
            userid = userdata.id;
        }

        const data = {
            files_categories_id:this.form2.controls['files_categories_id'].value,
            document_name:this.form2.controls['document_name'].value,
            picture:this.form2.controls['browsefile'].value,
            user_id:userid,
            rowid:this.rowId,


        };

        console.log(data);

        let parm = JSON.stringify(this.file_data);

         this.logService.createfile(data).subscribe(
            allfiles => {
                this.allfiles = allfiles;
                document.getElementById('catloader2').style.display = 'none';
                document.getElementById('catloader22').style.display = 'none';
                console.log(allfiles);
                this.form2.reset();
            },
            err => {
                console.log(err);
                document.getElementById('catloader2').style.display = 'none';
                document.getElementById('catloader22').style.display = 'none';
            }
        );
        }else {
            this.msgs = [];
            let sitting="";
            this.form2error=true;
            if(this.form2.controls['files_categories_id'].value==""){

                this.msgs.push({
                    severity: 'error',
                    summary: '',
                    detail: this.translate.instant('Please Choose Category Type')
                });
            }
            if(this.form2.controls['document_name'].value==""){
                this.msgs.push({
                    severity: 'error',
                    summary: '',
                    detail: this.translate.instant('Please Fill document Name')
                });
            }
            if(this.form2.controls['browsefile'].value==""){
                this.msgs.push({
                    severity: 'error',
                    summary: '',
                    detail: this.translate.instant('Please Choose Your document')
                });
            }



        }
    }

    changedisabled(event,status){
        console.log(event);
        this.fromscanner = status;
        if (status==1){
            this.downfils = false;
            document.getElementById('browsefile3').style.display = 'none';
            document.getElementById('browsefile2').style.display = 'block';
            if(localStorage.getItem('scannedImage')==""){
                document.getElementById('filedisu').style.display = 'none';
            }else{
                document.getElementById('filedisu').style.display = 'block';
            }
        }
        if (status==0){
            this.is_edit = false;
            document.getElementById('filedisu').style.display = 'none';
            document.getElementById('browsefile3').style.display = 'block';
            document.getElementById('browsefile2').style.display = 'none';
        }


    }

    isDisabled() : boolean{
    return this.is_edit;
    }

    close() {
        this.activeModal.dismiss('done');
        this.logService.clearfiles().subscribe();

    }

    preview(file:any , ext:any , i:any){
        //this.filedis = this.imgUrl+"files/image/"+ file;
        if(ext=="PDF" || ext=="IMAGE"){
            this.logService.getfileshow(file).subscribe(
                filedis => {
                    this.filedis = filedis;
                    console.log(filedis);

                },
                err => {
                    console.log(err);
                }
            );
            this.switch = 0;
        }else{
            this.filedis = this.imgUrl+"files/image/"+file;
            this.switch = 1;
        }
        this.filedisext = ext;
        this.filedisid = file;
        this.filedisindex = i;


        console.log(ext);
    }

     showDialog(file:any) {
        this.display = true;
        this.categ_delete_error="";
        this.categ_delete_error_h = this.translate.instant("Deatails");
        this.logService.getfiledById(file).subscribe(
            allfilesd => {
                this.filedetails = allfilesd;
                console.log(allfilesd);

            },
            err => {
                console.log(err);
            }
        );

    }

    createfilter(event ,filter:any){
        if(event.target.checked){
            if(filter == "all"){
                 for (let bran of  this.allcategory) {
                    this.catfilter.push(bran.value);
                }
            }else{
                let idx_u : any;
                idx_u = this.catfilter.indexOf(filter);
                if (idx_u == -1){
                    this.catfilter.push(filter);
                }
            }
        } else {
            if(filter == "all"){
                 this.catfilter=[];
            }else{
                let idx_u: any;
                 idx_u = this.catfilter.indexOf(filter);
                 if (idx_u !== -1) {
                     this.catfilter.splice(idx_u,1);
                 }
            }
        }
        if (this.catfilter.length == this.allcategory.length){
            this.checkedall=true;
        }else{
            this.checkedall=false;
        }
        console.log(this.catfilter);
    }

    onFileChange(event) {
        document.getElementById('filedisu').style.display = 'none';

        this.downfils = false;
        let reader = new FileReader();
        if (event.target.files && event.target.files.length > 0) {
            let file = event.target.files[0];
            reader.readAsDataURL(file);
            reader.onload = () => {
                this.form2.get('browsefile').setValue({
                    filename: file.name,
                    filetype: file.type,
                    value: reader.result.split(',')[1]
                })
            };
            this.downfil=file.name;
            this.downfils = true;
            localStorage.setItem('scannedImage', "");
        }
        console.log(this.downfil,this.downfils)
    }

    deleteFile(file:any) {
        //document.getElementById("catloader22").style.display = "block";
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if (file) {
                    this.logService.delete(file).subscribe(
                        res => {
                            this.allfiles = res;
                            //document.getElementById("catloader22").style.display = "none";
                        },
            err => {
                console.log(err);
                //document.getElementById("catloader22").style.display = "none";
            }
                    );
                }
            }
        });
    }

    zoomin() {
    this.zoom_to = this.zoom_to + 0.25;
  }

  zoomout() {
    if (this.zoom_to > 0.5) {
       this.zoom_to = this.zoom_to - 0.25;
    }
  }

  rotateright() {
    this.rotate_to = this.rotate_to + 90;
  }

  rotateleft() {
    this.rotate_to = this.rotate_to - 90;
  }


  fittowidthfun() : any{
      this.fittowidth = !this.fittowidth;
    }


    deletecategory(file:any,count:any) {

        if(count == 0){

            this.confirmationService.confirm({
                header: this.translate.instant('Confirm Delete'),
                message: this.translate.instant('Are you sure of delete ?'),
                icon: 'fa fa-trash',
                accept: () => {
                    if (file) {
                        document.getElementById('catloader11').style.display = 'block';
                        this.logService.deletecat(file, this.screenName).subscribe(
                            categories => {
                                this.allcategory = categories;
                                document.getElementById('catloader11').style.display = 'none';
                            },
                err => {
                    console.log(err);
                    document.getElementById('catloader11').style.display = 'none';
                }
                        );
                    }
                }
            });
        }else{
//            this.confirmationService.confirm({
//                header: this.translate.instant('Sorry Not Allowed'),
//                message: this.translate.instant('Sorry this Category has files'),
//                icon: 'fa fa-trash'
//            });
        this.categ_delete_error = this.translate.instant("Sorry this Category has files");
        this.categ_delete_error_h = this.translate.instant("Sorry Not Allowed");
        this.display = true;

            document.getElementById('catloader11').style.display = 'none';
        }
        document.getElementById('catloader11').style.display = 'none';

    }

    restoreLog(log: Log) {
        const options: NgbModalOptions = {

            beforeDismiss: () => {

                console.log('before dismiss');
                //
                return true;
            }
        };
        this.modalRef = this.modalService.open(this.refShow, options);
        this.modalRef.result.then(() => {
            this.activeModal.dismiss('done');
        }, () => {
            console.log('Backdrop click')
        });
        this.modalRef.componentInstance.oldData = log.old;
        this.modalRef.componentInstance.newData = log.new;
    }

    sannfile() {
        this.downfils = false;
        var scanRequest = {
            'use_asprise_dialog': true, // Whether to use Asprise Scanning Dialog
            'show_scanner_ui': false, // Whether scanner UI should be shown
            'twain_cap_setting': { // Optional scanning settings
                'ICAP_PIXELTYPE': 'TWPT_RGB' // Color
            },
            'output_settings': [
                            {
                                'type': 'return-base64',
                                'format': 'pdf',
                                'pdf_text_line': 'By ${USERNAME} on ${DATETIME}'
                            }
                        ]
        };
        scanner.scan(this.displayImagesOnPage, scanRequest);
    }

    displayImagesOnPage(successful, mesg, response) {
      if (!successful) { // On error
        console.error('Failed: ' + mesg);
        return;
      }
      if (successful && mesg != null && mesg.toLowerCase().indexOf('user cancel') >= 0) { // User cancelled.
        console.info('User cancelled');
        return;
      }
      console.log(scanner.getScannedImages(response, true, false));
      let scannedImages2 = scanner.getScannedImages(response, true, false);
      console.log(scannedImages2);


      for (var i = 0; (scannedImages2 instanceof Array) && i < scannedImages2.length; i++) {
        let scannedImage = scannedImages2[i];
        //this.imagesScanned.push(scannedImage);
        //console.log(this.imagesScanned);
        processOriginal(scannedImage);
      }

    }
    downloading(file) {
      window.open(file);
    }

  downloadFile(data) {
    var blob = new Blob([data], { type: 'application/pdf' });
    var url= window.URL.createObjectURL(blob);
    window.open(url);
  }

  nextfile(){
      let len_array = this.allfiles.length;
      //let showfile = this.filedisindex;
      console.log(this.allfiles.length);
      console.log(this.filedisindex);
      if (this.filedisindex < len_array && this.filedisindex <= len_array-2 ){
          if(this.allfiles[this.filedisindex+1]!==''){
              console.log(this.filedisindex);
          this.filedisindex = this.filedisindex+1;
          this.filedisext = this.allfiles[this.filedisindex].ext;
          this.filedisid = this.allfiles[this.filedisindex].id;
          this.preview(this.filedisid, this.filedisext, this.filedisindex);
          }else{
              this.filedisindex = this.filedisindex+1;
          }
      }
  }

    prevfile(){
      let len_array = this.allfiles.length;
      //let showfile = this.filedisindex;
      console.log(this.allfiles.length);
      console.log(this.filedisindex);
      if (this.filedisindex < len_array && this.filedisindex >=0){
          if(this.allfiles[this.filedisindex-1]!==''){
              console.log(this.filedisindex);
          this.filedisindex = this.filedisindex-1;
          this.filedisext = this.allfiles[this.filedisindex].ext;
          this.filedisid = this.allfiles[this.filedisindex].id;
          this.preview(this.filedisid, this.filedisext, this.filedisindex);
          }else{
              this.filedisindex = this.filedisindex-1;
          }
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/app-arc/app-arc.component.ts